<!--
 * @Author: your name
 * @Date: 2020-08-13 15:24:30
 * @LastEditTime: 2020-08-27 22:15:47
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /frontend-user/src/views/contact-details/component/SmallIcon/index.vue
-->
<style scoped lang="sass">
.small_icon
  display: flex
  align-items: center
  justify-content: center
  height: 40px
  width: 40px
  margin: 15px 0
  border-radius: 50%
  background: rgba(51, 68, 85, 0.08)
  flex-shrink: 0

  .icon
    color: #94979A !important
</style>

<template lang="pug">
.small_icon
  icon(:size="size").icon {{ icon }}
</template>

<script>
import Vue from 'vue'
import Component from 'vue-class-component'

@Component({
  props: {
    icon: {
      type: String,
      default: 'mail'
    },
    size: {
      type: [String, Number],
      default: 28
    }
  }
})
class SmallIcon extends Vue {
}

export default SmallIcon
</script>
